import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./CabListing.css";
import { Col, Container, Row } from "react-bootstrap";
import CabFilters from "./CabFilters";
import CabSearchModify from "./CabSearchModify";
import { IoArrowBackSharp } from "react-icons/io5";
import { IoSearch } from "react-icons/io5";
import { MdEdit } from "react-icons/md";
import { MdRoute } from "react-icons/md";
import { IoMdTime } from "react-icons/io";
import axios from "axios";
import dayjs from "dayjs";
import CabListSkeleton from "./CabListSkeleton";

const CabListing = () => {
  const location = useLocation();
  const [cabSearchData, setCabSearchData] = useState([]);
  const [pickup, setPickup] = useState("");
  const [drop, setDrop] = useState("");
  const [startDate, setStartDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [allCabs, setAllCabs] = useState([]);
  const [filteredCabs, setFilteredCabs] = useState([]);
  const [priceLimits, setPriceLimits] = useState([0, 0]);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const pickup = params.get("pickup");
    const drop = params.get("drop");
    const startDate = params.get("startDate");
    const endDate = params.get("endDate");
    const startTime = params.get("startTime");
    const endTime = params.get("endTime");

    setPickup(pickup);
    setDrop(drop);
    setStartDate(startDate);
    setStartTime(startTime);

    const searchRequestData = {
      type: "One Way Trip", 
      pickup: pickup,
      plat: "28.6434",
      plng: "77.2220",
      drop: drop,
      dlat: "28.5562",
      dlng: "77.1000",
      start_date: startDate,
      start_time: startTime,
      end_date: endDate, 
      end_time: endTime, 
    };

    const fetchCabList = async () => {
      setLoading(true); 
      const response = await axios.post(
        "https://admin.travelsdata.com/api/Cab/Search",
        searchRequestData
      );
    
      // const cabs = response.data.data.data.cabs;
      const cabs = response?.data?.data?.data?.cabs || [];
      
      setAllCabs(cabs);
      setFilteredCabs(cabs);
      if (cabs.length > 0) {
        const prices = cabs.map((cab) => Number(cab.price));
        const minPrice = Math.min(...prices);
        const maxPrice = Math.max(...prices);
        setPriceLimits([minPrice, maxPrice]);
      }
      setLoading(false);
    };
    fetchCabList();
  }, [location.search]);

  
  // This function stays here
  const applyFilters = (priceRange, cabTypes, seaters) => {
    let filtered = allCabs; // Start with all cabs fetched from API

    // Price Range filter
    filtered = filtered.filter(
      (cab) =>
        Number(cab.price) >= priceRange[0] && Number(cab.price) <= priceRange[1]
    );
    // Cab Type filter
    if (cabTypes.length > 0) {
      filtered = filtered.filter((cab) =>
        cabTypes.some((type) =>
          cab.name.toLowerCase().includes(type.toLowerCase())
        )
      );
    }
    // Seaters filter
    if (seaters.length > 0) {
      filtered = filtered.filter((cab) =>
        seaters.some((seatStr) => {
          const num = parseInt(seatStr);
          return Number(cab.total_seats) === num;
        })
      );
    }

    //Save results so UI updates
    setFilteredCabs(filtered);
  };

  const navigate = useNavigate();

  const handleBookNow = (cab) => {
    const params = new URLSearchParams(location.search);
    const pickup = params.get("pickup");
    const drop = params.get("drop");
    const startDate = params.get("startDate");
    const endDate = params.get("endDate");
    const startTime = params.get("startTime");
    const endTime = params.get("endTime");

    const selectedFields = {
      pickup,
      drop,
      start_date: startDate,
      end_date: endDate,
      start_time: startTime,
      end_time: endTime,
    };
    localStorage.setItem("selectedCab", JSON.stringify(cab));
    // localStorage.setItem("searchParams", location.search);
    localStorage.setItem("cabSearchSelected", JSON.stringify(selectedFields));
    console.log("SelectedCabs Data:", cab);
    console.log("cabSearchSelected Data:", selectedFields);
    navigate("/cabdetails");
  };

  

  return (
    <div className="cabListing">
      <div className="cabListing-DesktopContainer">
        <CabSearchModify />

        <Container className="cabListing-Container">
          <Row>
            <Col md={3}>
              <CabFilters
                applyFilters={applyFilters}
                priceLimits={priceLimits}
                cabData={allCabs}
              />
            </Col>

            <Col md={9}>
              {loading ? (
                <CabListSkeleton count={5} />
              ) : filteredCabs && filteredCabs.length !== 0 ? (
                filteredCabs.map((cab, index) => (
                  <div key={index} className="CabListingWrapper">
                    <div className="CabCard">
                      <Col>
                        <div className="CabCardImgWrapper">
                          <div className="CabCardTopRow">
                            <h3 className="CabCarTitle">{cab.name}</h3>
                            <div className="CabCarSpecs">
                              <span className="CabSpecText">
                                {cab.total_seats} Seat
                              </span>
                            </div>
                          </div>
                          <img
                            src={cab.image}
                            alt="Toyota Etios"
                            className="CabCarImage"
                          />
                        </div>
                      </Col>
                      <div className="CabCardContent">
                        <div className="CabDetailsGrid">
                          <div className="CabDetailItem">
                            <p className="CabDetailTitle">Kilometer Charges</p>
                            <p className="CabDetailText">
                              {cab.distance} km Included after that{" "}
                              <strong>{cab.extra_per_km} km</strong> charge
                              applicable
                            </p>
                          </div>
                          <div className="CabDetailItem">
                            <p className="CabDetailTitle">Fuel Type</p>
                            <p className="CabDetailText">CNG/Petrol/diesel</p>
                          </div>
                          <div className="CabDetailItem">
                            <p className="CabDetailTitle">
                              Cancellation Policy
                            </p>
                            <p className="CabDetailText">{cab.cancellation}</p>
                          </div>
                        </div>
                        <div className="CabFooter">
                          <span>✔ 24/7 customer helpline</span>
                        </div>
                      </div>
                      <div className="CabCardRight">
                        <div className="CabPrice">₹ {cab.price}</div>
                        <button
                          onClick={() => handleBookNow(cab)}
                          className="CabBookBtn"
                        >
                          Book Now
                        </button>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p style={{ textAlign: "center" }}>No cabs available</p>
              )}
            </Col>
          </Row>
        </Container>
      </div>

      {/* Mobile View */}

{loading ? (
  <CabListSkeleton count={5} mobile />
) : filteredCabs && filteredCabs.length > 0 ? (
  filteredCabs.map((cab, index) => (

        <div className="cabMobile-container">
          {/* Top Bar */}
          <div className="cabMobile-topbar">
            <button className="cabMobile-iconBtn">
             <Link to="/cabs"> <IoArrowBackSharp /></Link>
            </button>
            <div className="cabMobile-topbar-location">
              {/* <span className="cabMobile-live">LIVE</span> */}
              <strong>From: {pickup}</strong>
              <br/>
              <strong>To: {drop}</strong>

              <div>
                {startDate && startTime
                  ? `${dayjs(startDate).format("DD MMM YYYY")}, ${startTime}`
                  : ""}
              </div>
            </div>
            <div className="cabMobile-topbar-actions">
              {/* <button
                className="cabMobile-iconBtn"
                style={{ marginRight: "5px" }}
              >
                <IoSearch />
              </button> */}
              <button className="cabMobile-iconBtn">
               <Link to="/cabs"><MdEdit /></Link>
              </button>
            </div>
          </div>
          <Container>
            {/* Route Summary */}
            <div className="cabMobile-routeBox">
              <div className="cabMobile-routeBoxDisplay">
                <div className="cabMobile-points">
                  <div className="cabMobile-PickupPoint">
                    <div className="cabMobile-dot green" />
                    <div>
                      <strong>{pickup}</strong>
                      <div className="cabMobile-PickupPoint">{pickup}</div>
                    </div>
                  </div>

                  <div className="cabMobile-lineDisplay">
                    <div className="cabMobile-line"></div>
                  </div>

                  <div className="cabMobile-DropPoint">
                    <div className="cabMobile-dot red" />
                    <div>
                      <strong>{drop}</strong>
                      <p>{drop}</p>
                    </div>
                  </div>
                </div>

                <div className="cabMobile-info">
                  <div>
                    <MdRoute /> 26 km
                  </div>
                  <div>
                    <IoMdTime /> 45 min
                  </div>
                  <div>₹ 879+</div>
                </div>
              </div>
            </div>

            {/* Tabs */}
            <div className="cabMobile-tabs">
              <button className="active">✨ Best Match</button>
              <button>🚀 Fastest</button>
              <button>💸 Cheapest</button>
              <button>💸 Premium</button>
            </div>

            {/* Cab Card */}
            {filteredCabs &&
              filteredCabs.map((cab, index) => (
                <div
                  onClick={() => handleBookNow(cab)}
                  className="cabMobile-cardMain"
                >
                  <div className="cabMobile-card">
                    <img
                      src={cab.image}
                      alt="Cab"
                      className="cabMobile-carImg"
                    />
                    <div className="cabMobile-cardContent">
                      <div className="cabMobile-cardHeader">
                        <div>{cab.name}</div>
                        <span className="cabMobile-rating">⭐ 4.9</span>
                        <span className="cabMobile-eta">ETA 3 min</span>
                      </div>

                      <div className="cabMobile-tags">
                        <span>AC</span>
                        <span>Music</span>
                      </div>
                    </div>
                  </div>
                  <div className="cabMobile-priceMain">
                    <div className="cabMobile-price">
                      <strong>₹ {cab.price}</strong>
                      <span className="cabMobile-strike">₹841</span>
                    </div>
                    <div className="cabMobile-offer">
                      ✅ TGOCAB Applied • Save ₹4
                    </div>
                  </div>
                </div>
              ))}
          </Container>
        </div>
  ))
) : (
  <p style={{ textAlign: "center" }}></p>
)}
    </div>
  );
};

export default CabListing;
